import { render, staticRenderFns } from "./tabSupplements.vue?vue&type=template&id=e13df8b6&scoped=true"
import script from "./tabSupplements.vue?vue&type=script&lang=js"
export * from "./tabSupplements.vue?vue&type=script&lang=js"
import style0 from "./tabSupplements.vue?vue&type=style&index=0&id=e13df8b6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e13df8b6",
  null
  
)

export default component.exports